export const JOB_REGION = Object.freeze([
  {
    label: 'Worldwide (All)',
    value: 'worldwide'
  },
  {
    label: 'APAC (Japan, China, India, Australia, Bangladesh etc.)',
    value: 'apac'
  },
  {
    label: 'LATAM (Latin America, Central & South America)',
    value: 'latam'
  },
  {
    label: 'EMEA (Europe, Middle East, and Africa)',
    value: 'emea'
  },
  {
    label: 'North America',
    value: 'north-america'
  }
]);

export const DEFAULT_COMPANY_LIST_LOGO_URL = 'https://placehold.co/150x150?text=Logo'
export const DEFAULT_COMPANY_TABLE_URL = 'https://placehold.co/70x70?text=Logo'

export const GEEKIFY_ME_TABLE_ROWS_PER_PAGE = "geekify-me-public-table-rows-per-page";

export const CANDIDATE_AVAILABILITY_STATUS = [{
  label: 'Actively Looking',
  value: 'actively_looking'
}, {
  label: 'Passively Looking',
  value: 'passively_looking'
}, {
  label: 'Engaged',
  value: 'engaged'
}, {
  label: 'Not Looking',
  value: 'not_looking'
}, {
  label: 'Part time',
  value: 'part_time'
}]